import {load} from '@shopify/theme-sections';
import '../sections/product';
import '../sections/recipe-recommendations';
import '../sections/product-recommendations';
import '../sections/instagram-feed';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
